<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/15Hc4b6/tc-custom/9781514002292.jpg?1696024830065" alt="This image is the cover for the book The Unhiding of Elijah Campbell"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Unhiding of Elijah Campbell
      </h1>
      <p class="bookDescription body article font2">
        <p> <strong>Illumination Book Award</strong> </p> <p> <strong>Nautilus Book Award</strong> </p> <p> <strong>Elijah Campbell is on the verge of losing his writing career, his faith, and his marriage when a recurring childhood nightmare drives him back to his hometown, Bradford's Ferry.</strong> There, his encounters with loved ones both past and present shed light on the reason his wife left him—and the meaning of his nightmare. However, beyond the light he begins to glimpse something even more terrifying—a decision he must make either to continue hiding the secrets of his past or unhide the only thing that can save his marriage: himself.</p> <p>In psychologist Kelly Flanagan's non-fiction works (<em>Loveable</em>, <em>True Companions</em>), he drew from clinical insight to explore the spiritual depths of identity and relationships. Now, in this debut novel, he weaves a page-turning and plot-twisting tale that brings new life to those insights, along with fresh revelations about personal growth, spiritual transformation, and the dynamics of interpersonal relationships.</p> <p>This visit to Bradford's Ferry will linger long after the final page has been turned, and a guide for group discussion invites further conversation about the story's themes of healing, grace, faith, forgiveness, and freedom.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Kelly Flanagan
      </h2>
      
      <p class="authorDescription body article"><p>Kelly Flanagan (PhD, Pennsylvania State University) is a clinical psychologist, popular speaker, and the author of <em>The Marriage Manifesto</em>, <em>Loveable</em>, and <em>True Companions</em>. He has also written for publications such as <em>Christianity Today</em>, <em>Reader's Digest</em>, and <em>Huffington Post</em>, and he has appeared on the <em>TODAY Show</em> with his daughter. He lives in Dixon, Illinois, with his wife who is also named Kelly, and their three children.</p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      InterVarsity Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?90e8f9a6